export default "__VITE_ASSET__d049e966__"